var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.trackStyle),on:{"click":_vm.toggleSwitch}},[_c('div',{style:(_vm.labelStyle)},[_vm._v(_vm._s(_vm.isOn ? "Shown" : "Hidden"))]),_c('div',{style:(_vm.knobStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }